import AxiosPermisos from "@/services/axiosPermisos";

import { paths } from "./path";
import { map_query } from "@/core/functions/map-path-query";

const getLicenses = async ({ data = {} }) =>
  await AxiosPermisos.get(paths.licenses.concat(map_query(data)), true, "v2");

const getLicense = (id) =>
  AxiosPermisos.get(paths.license.replace(":id", id), true, "v2");

const getLicenseHistory = (id) =>
  AxiosPermisos.get(paths.licenseHistory.replace(":id", id), true, "v2");

const getLicenseManagementService = (id, management) =>
  AxiosPermisos.get(
    paths.licenseManagement
      .replace(":id", id)
      .replace(":management", management),
    true,
    "v2"
  );

const putLicenseManagementService = (id, management, data) =>
  AxiosPermisos.postSendFile(
    paths.licenseManagement
      .replace(":id", id)
      .replace(":management", management),
    true,
    data,
    "v2"
  );

export {
  getLicenses,
  getLicense,
  getLicenseManagementService,
  putLicenseManagementService,
  getLicenseHistory,
};
